type SectionType = {
	uuid: string;
	label: string;
	value: string;
};

export const sectionTypes: SectionType[] = [
	{
		uuid: "9f00e375-ad46-45b3-8dfe-52c6b837919e",
		label: "Video",
		value: "VIDEO",
	},
	{
		uuid: "9f00e375-ad4f-4310-b02c-b71cc50b39b4",
		label: "Quiz",
		value: "QUIZ",
	},
];
